import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [school, setSchool] = useState({ name: "مدارس السمو الأهلية للبنات", logo_url: "", app_name: "بقدراتنا نسمو" });
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            setUser(null);
            localStorage.removeItem("bqns_token");
        }
    }, []);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/config/school");
                setSchool(data);
            } catch {}
            await refresh();
            setLoading(false);
        })();
    }, [refresh]);

    const login = async (username, password) => {
        const { data } = await api.post("/auth/login", { username, password });
        localStorage.setItem("bqns_token", data.token);
        setUser(data.user);
        return data.user;
    };

    const logout = async () => {
        try { await api.post("/auth/logout"); } catch {}
        localStorage.removeItem("bqns_token");
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, setUser, school, loading, login, logout, refresh }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
